import { render } from "./SubmitDevoirPage.vue?vue&type=template&id=26a891f6&ts=true"
import script from "./SubmitDevoirPage.vue?vue&type=script&lang=ts"
export * from "./SubmitDevoirPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__